import React from 'react';

import * as dataCollectionTypes from '../../../../consts/uam/dataCollectionTypes';
import DataCollectionBaseHandler from './DataCollectionBaseHandler';

const DataCollectionDiagnosticHandler = () => {
    return <DataCollectionBaseHandler dataCollectionType={dataCollectionTypes.DATA_COLLECTION_DIAGNOSTIC} />;
};

export default DataCollectionDiagnosticHandler;
